export default {
  "ThirdPartyOneTouchItem.ColumnName1": "基本情報",
  "ThirdPartyOneTouchItem.ColumnName2": "法人ユーザー情報",
  "ThirdPartyOneTouchItem.ColumnName3": "利用情報",
  "ThirdPartyOneTouchItem.ColumnName4": "位置情報",
  "ThirdPartyOneTouchItem.ColumnName5": "医療健康情報",
  "ThirdPartyOneTouchItem.RowName1": "ドコモ",
  "ThirdPartyOneTouchItem.RowName2": "グループ",
  "ThirdPartyOneTouchItem.RowName3": "NTT",
  "ThirdPartyOneTouchItem.RowName4": "グループ",
  "ThirdPartyOneTouchItem.RowName5": "その他",
  "ThirdPartyOneTouchItem.RowName6": "提携先",
}
